import React, { useState } from 'react';
import clx from 'classnames';
import { useFm } from '@web3/base-hooks';
import {
  PRICE_POOL_CONTENT_EXTEND_IMG,
  PRICE_POOL_CONTENT_SIDE_IMG,
  PRICE_POOL_ICON_LEFT_IMG,
  PRICE_POOL_ICON_RIGHT_IMG,
} from '@/constants';
import { initialWindowType } from '@/hooks/media';

import styles from './index.module.scss';
import {
  DAILY_REWARD_AMOUNT,
  GRANT_REWARD_AMOUNT,
  TOTAL_REWARD_AMOUNT,
  TOKEN_NAME,
  GRANT_REWARD_PERSONAL_TOP,
  GRANT_REWARD_BASE,
} from '@/utils/constant';

const PrizePool = () => {
  const fm = useFm();
  const { isMobile } = initialWindowType;
  const [extendLeft, setExtendLeft] = useState(false);
  const [extendRight, setExtendRight] = useState(false);

  return (
    <div
      className={clx([
        'flex flex-col items-center w-full',
        !isMobile ? 'gap-[40px]' : 'gap-[24px]',
      ])}
    >
      <div className={styles.title}>
        {fm('prizePoolAmount', { amount: TOTAL_REWARD_AMOUNT })}
      </div>
      <div className={styles.row}>
        {/* grand */}
        <div className={styles.priceItem}>
          <img src={PRICE_POOL_ICON_LEFT_IMG} alt="icon" />
          <div className={styles.content}>
            <img
              className={styles.left}
              src={PRICE_POOL_CONTENT_SIDE_IMG}
              alt="leftSide"
            />
            <div className={styles.middle}>
              <div className={styles.label}>{fm('bannerGrandPrizePool')}</div>
              <div className={styles.value}>{`$${GRANT_REWARD_AMOUNT}`}</div>
            </div>
            <img
              className={styles.right}
              src={PRICE_POOL_CONTENT_SIDE_IMG}
              alt="leftSide"
            />
          </div>
          <div className={clx([styles.remark, extendLeft && styles.showAll])}>
            {fm('voteProjectsRewardsNotice', {
              amount1: GRANT_REWARD_BASE,
              amount2: GRANT_REWARD_PERSONAL_TOP,
            })}
          </div>
          {isMobile && (
            <div
              className={clx([styles.extend, extendLeft && styles.active])}
              onClick={() => setExtendLeft(!extendLeft)}
            >
              <img src={PRICE_POOL_CONTENT_EXTEND_IMG} alt="extand" />
            </div>
          )}
        </div>
        {/* daily */}
        <div className={styles.priceItem}>
          <img src={PRICE_POOL_ICON_RIGHT_IMG} alt="icon" />
          <div className={styles.content}>
            <img
              className={styles.left}
              src={PRICE_POOL_CONTENT_SIDE_IMG}
              alt="leftSide"
            />
            <div className={styles.middle}>
              <div className={styles.label}>{fm('dailyLuckyDraw')}</div>
              <div className={styles.value}>{`$${DAILY_REWARD_AMOUNT}`}</div>
            </div>
            <img
              className={styles.right}
              src={PRICE_POOL_CONTENT_SIDE_IMG}
              alt="leftSide"
            />
          </div>
          <div className={clx([styles.remark, extendRight && styles.showAll])}>
            {fm('dailyTokenUnlockChance', {
              amount: `$${DAILY_REWARD_AMOUNT}`,
              tokenName: '',
            })}
          </div>
          {isMobile && (
            <div
              className={clx([styles.extend, extendRight && styles.active])}
              onClick={() => setExtendRight(!extendRight)}
            >
              <img src={PRICE_POOL_CONTENT_EXTEND_IMG} alt="extand" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrizePool;
